import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { TICKET_MODULE_NAMESPACE, TICKET_GET_CHARACTER_PROBLEMS } from '../../../store/ticket';

const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
@Component({
  components: {
    'detail-header': async () => import('../components/block-detail-header/BlockDetailHeader.vue')
  }
})
class BlockChildDetail extends Vue {

  /**
   *
   */
  constructor() {
    super();
  }
  @TicketStore.Action(TICKET_GET_CHARACTER_PROBLEMS)
  storeGetCharacterProblems: () => void;
  mounted() {
    this.storeGetCharacterProblems();
  }
}

export default BlockChildDetail;



// WEBPACK FOOTER //
// ./src/containers/block/block-child-detail/index.ts